module.exports = __webpack_public_path__ + "img/repetir.11df4b96.svg";